import { Injectable } from '@angular/core';
import { Data } from '@angular/router';

interface ObjPesquisar {
	inicio: Date;
	fim: Data;
	entidade: any;
	tipoFiltro: string;
}

@Injectable({
	providedIn: 'root',
})
export class StateRouteJornadaService {
	JORNADA_PESQUISAR = 'jornada';
	private objPesquisar: ObjPesquisar = {inicio: null, fim: null, entidade: null, tipoFiltro: ''};
	constructor() {}


	setObjPesquisar(objPesquisar: ObjPesquisar) {
		this.objPesquisar = objPesquisar;
		localStorage.setItem(this.JORNADA_PESQUISAR, JSON.stringify(objPesquisar));
	}

	getObjPesquisar(): ObjPesquisar {
		const jornada = JSON.parse(localStorage.getItem(this.JORNADA_PESQUISAR));
		if (jornada) {
			const { inicio, fim, entidade, tipoFiltro } = jornada;
			const objJornada = {inicio: new Date(inicio), fim: new Date(fim) , entidade, tipoFiltro};
			this.objPesquisar = objJornada;
			return objJornada;
		}
		return this.objPesquisar;
	}

	limparLocalStorage() {
		localStorage.clear();
	}
}
